import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    component: () => import('./Blank.vue'),
    name: '',
  },
  {
    path: '/support',
    component: () => import('../components/views/Support/Support.vue'),
    name: 'support',
  },
  {
    path: '/support/faq',
    component: () => import('../components/views/Support/SupportFaq.vue'),
    name: 'support-faq',
  },
  {
    path: '/support/contact',
    component: () => import('../components/views/Support/SupportContact.vue'),
    name: 'support-contact',
  },
  {
    path: '/whats-on',
    component: () => import('../components/views/WhatsOn/WhatsOn.vue'),
    name: 'whats-on',
  },
  {
    path: '/whats-on/:id',
    component: () => import('../components/views/WhatsOn/WhatsOnDetail.vue'),
    name: 'whats-on-detail',
  },
  {
    path: '/locations',
    component: () => import('../components/views/Locations/Locations.vue'),
    name: 'locations',
  },
  {
    path: '/locations/updated',
    component: () => import('../components/views/Locations/Locations.vue'),
    name: 'location-updated',
  },
  {
    path: '/locations/:id',
    component: () => import('../components/views/Locations/Location.vue'),
    name: 'edit-location',
  },
  {
    path: '/locations/:id/demo',
    component: () => import('../components/views/Locations/Location.vue'),
    name: 'demo-location',
  },
  {
    path: '/locations/:id/skip-demo',
    component: () => import('../components/views/Locations/Location.vue'),
    name: 'skip-demo-location',
  },
  {
    path: '/locations/:id/existing-new',
    component: () => import('../components/views/Locations/Location.vue'),
    name: 'existing-new-location',
  },
  {
    path: '/players',
    component: () => import('../components/views/Players/Players.vue'),
    name: 'players',
  },
  {
    path: '/samples',
    component: () => import('../components/views/Samples/Samples.vue'),
    name: 'samples',
  },
  {
    path: '/samples/:id',
    component: () => import('../components/views/Samples/Sample.vue'),
    name: 'sample',
  },
  {
    path: '/documents',
    component: () => import('../components/views/Documents/Documents.vue'),
    name: 'documents',
  },
  {
    path: '/documents/:id',
    component: () => import('../components/views/Documents/Document.vue'),
    name: 'document',
  },
  {
    path: '/update_payments',
    component: () => import('../components/views/Payments/UpdatePayments.vue'),
    name: 'update_payments',
  },
  {
    path: '/creative/:id',
    component: () => import('../components/views/Creative/CreativeDetail.vue'),
    name: 'creative-detail',
  },
  {
    path: '/creative',
    component: () => import('../components/views/Creative/Creative.vue'),
    name: 'creative',
  },
  {
    path: '/creative/:id/website',
    component: () => import('../components/views/Creative/CreativeWebsite.vue'),
    name: 'creative-website',
  },
  {
    path: '/jimmyjohns',
    component: () => import('../components/views/TPG/jimmyjohns/JJMainLayout.vue'),
    name: 'jj_main',
  },
  {
    path: '/jimmyjohns/jj_signup',
    component: () => import('../components/views/TPG/jimmyjohns/JJSignup.vue'),
    name: 'jj_signup',
  },
  {
    path: '/jimmyjohns/update_payment',
    component: () => import('../components/views/TPG/jimmyjohns/JJUpdatePayment.vue'),
    name: 'update_payment',
  },
  {
    path: '/jimmyjohns/payment_update_success',
    component: () => import('../components/views/TPG/jimmyjohns/JJMainLayout.vue'),
    name: 'payment_update_success',
  },
  {
    path: '/password/reset/:token',
    component: () => import('../components/views/Auth/ResetPassword.vue'),
    name: 'password_reset',
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
